module.exports = __webpack_public_path__ + "assets/img/vivium-groep.770b8067.png";